import React, { Component } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Typo, HR as _HR, Icon as _Icon } from 'tmt-ui-kit';

const Container = styled.div`
  display: ${props => (props.isSeeAll ? 'none' : 'display: block')};
`;

const HeaderContainer = styled.div`
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  padding-right: 10px;
`;

const CollapsedContent = styled.div`
  width: 100%;
  height: ${props => (props.active ? '100%' : '0')};
  border-radius: 6px;
  background-color: ${props => props.theme.blueGray};
  overflow: hidden;
`;
const Content = styled.div`
  padding: 16px;
`;
// opacity: ${props => (props.active ? '1' : '0')};
const CollapsedButton = styled.button`
  cursor: pointer;
  background-color: transparent;
  border: none;
  padding: 0px;
`;

const Icon = styled(_Icon)`
  font-size: 24px;
  color: ${props => props.theme.lightBlue};
`;

const HR = styled(_HR) `
  margin-bottom: 16px;
`;

const getInitialState = props => ({
  isActive: props.isActive
});

class Collapsed extends Component {
  static propTypes = {
    header: PropTypes.string,
    content: PropTypes.any,
    isSeeAll: PropTypes.bool,
    seeAll: PropTypes.bool,
    // isActive: PropTypes.bool,
    index: PropTypes.number,
    onClickSetContentIndex: PropTypes.func
  };

  state = getInitialState(this.props);

  render() {
    const { isActive } = this.state;
    const { header, content, isSeeAll, seeAll } = this.props;
    return (
      <Container onClick={() => this.props.onClickSetContentIndex(this.props.index)} isSeeAll={seeAll === true ? !seeAll : isSeeAll}>
        <HeaderContainer onClick={() => this.setState({ isActive: !isActive })} >
          <Typo.Regular>{header}</Typo.Regular>
          <CollapsedButton>
            <Icon name={isActive ? 'chevron-up' : 'chevron-down'} />
          </CollapsedButton>
        </HeaderContainer>
        <CollapsedContent active={isActive}>
          <Content active={isActive}>
            {content}
          </Content>
        </CollapsedContent>
        <HR />
      </Container>
    );
  }
}

export default Collapsed;
